import ItemDetails, { Record } from './item-details';

export default ItemDetails;

export { Record };



// WEBPACK FOOTER //
// ./src/components/item-details/index.js